import isMoreThan from "../validations/is.more.than";

export default (values, value, maxValue) => isMoreThan(Number(value), maxValue);
